/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Phone_Is_Phone_Book_EnabledInputs */

const en_forms_users_settings_phone_is_phone_book_enabled = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Phone_Book_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const de_forms_users_settings_phone_is_phone_book_enabled = /** @type {(inputs: Forms_Users_Settings_Phone_Is_Phone_Book_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressbuch aktiviert`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Forms_Users_Settings_Phone_Is_Phone_Book_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_phone_is_phone_book_enabled = /** @type {((inputs?: Forms_Users_Settings_Phone_Is_Phone_Book_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Phone_Is_Phone_Book_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_phone_is_phone_book_enabled(inputs)
	return de_forms_users_settings_phone_is_phone_book_enabled(inputs)
});